import React from "react";
import { CarPreview } from "../car-preview";
import "./index.css";
import { Car } from "../../types";

interface Props {
  cars: Car[];
}

export const CarList: React.FC<Props> = ({ cars }) => {
  return (
    <section className="CarList">
      {cars.map((car) => (
        <CarPreview key={car.id} car={car} />
      ))}
    </section>
  );
};
